import { LoadingScreen } from "Components";

export function LoadingComponent({ children, isLoading }) {
  return isLoading ? (
    <div
      className="position-relative"
      style={{ width: "100%", height: "calc(100vh - 120px)" }}
    >
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1000,
        }}
      >
        <LoadingScreen />
      </div>
    </div>
  ) : (
    children
  );
}
